export const ALL_RETAINER_PERIODS_ID = -1;
